import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
} from "@angular/core";
import { CanvasService } from "../../canvas/canvas-service.interface";

@Component({
  selector: "wound-site-notes",
  templateUrl: "wound-site-notes.html",
})
export class WoundSiteNotesComponent implements AfterViewInit {
  @Input() painService: CanvasService;
  @Input() config: any;
  points = [];
  noneActive: boolean = true;
  subscriptions: Array<any> = [];

  constructor(private cdr: ChangeDetectorRef) {
    console.log("Hello PainSiteCardSidebarComponent Component");
  }

  ngAfterViewInit() {
    this.subscriptions.push(
      this.painService.getAllPointDataObservable().subscribe((data) => {
        if (!data || !data.points) {
          return;
        }

        let points = data.points;
        this.points = points;

        this.noneActive = !this.checkActive();
      })
    );
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    for (let sub of this.subscriptions) {
      sub.unsubscribe();
    }
    this.subscriptions = [];
  }

  checkActive() {
    for (let i = 0; i < this.points.length; i++) {
      if (this.points[i].active) {
        return true;
      }
    }
    return false;
  }

  updateActivePointData(key, value) {
    this.painService.updateActivePointData(key, value);
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/wound-site-notes/wound-site-notes.ts